export const ASSIGNEE = 'assignee'
export const ACCOUNT_DETAILS = 'account_details'
export const OPPORTUNITY_DETAILS = 'opportunity_details'
export const SAVE_TASK = 'save_task'
export const UPDATE_TASK = 'update_task'
export const REMOVE_TASK = 'remove_task'
export const TASK_TYPES = 'task_type'
export const TASK_BY_ID = 'task_by_id'
export const TASK_LISTING = 'task_listing'
export const TASK_FILTER = 'task_filter'